export enum CSharpTypes {
    DateTime = 'DateTime',
    String = 'String',
    Decimal = 'Decimal',
    Single = 'Single',
}
